import { render, staticRenderFns } from "./RadioBox.vue?vue&type=template&id=78f54eec&scoped=true&"
import script from "./RadioBox.vue?vue&type=script&lang=js&"
export * from "./RadioBox.vue?vue&type=script&lang=js&"
import style0 from "./RadioBox.vue?vue&type=style&index=0&id=78f54eec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f54eec",
  null
  
)

export default component.exports